import { render, staticRenderFns } from "./Dashboard-card.vue?vue&type=template&id=665a5307&scoped=true"
import script from "./Dashboard-card.vue?vue&type=script&lang=js"
export * from "./Dashboard-card.vue?vue&type=script&lang=js"
import style0 from "./Dashboard-card.vue?vue&type=style&index=0&id=665a5307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a5307",
  null
  
)

export default component.exports